import { NotificationTarget } from "@datagame/ui";
import { Route, Routes, useLoaderData } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import { GlobalConfigurationProvider } from "./contexts/globalConfiguration";
import { LeaderboardPage } from "./pages/LeaderboardPage";
import { ProjectPage } from "./pages/ProjectPage";
import { ProjectPublic } from "./gql/graphql";
import { ProjectLeaderboardPage } from "./pages/ProjectLeaderboardPage";
import { MetaPixel } from "./components/MetaPixel";

function App() {
  const configuration = useLoaderData() as ProjectPublic;
  const isDesktop = useMediaQuery({ query: "(min-width: 1280px)" });

  return (
    <GlobalConfigurationProvider configuration={configuration}>
      <MetaPixel />
      <NotificationTarget
        position={isDesktop ? "bottom-right" : "top-center"}
        toastOptions={{
          duration: 4000,
        }}
      />
      <Routes>
        <Route path="/" element={<ProjectPage />} />
        {/* Project leaderboard */}
        <Route path="/leaderboard" element={<ProjectLeaderboardPage />} />
        {/* Game leaderboard */}
        <Route path="/:gameId/leaderboard" element={<LeaderboardPage />} />
      </Routes>
    </GlobalConfigurationProvider>
  );
}

export default App;
